// CalibrationLogBookEntry.js
// A single calibration row within a standalone Calibration Log Book.
// Generic clone of WaterCalibrationLog: parent id is generic and toPatch accepts an injected
// patch_type so the shared calibration UI can drive either context.
import { v4 as uuidv4 } from "uuid";

export class CalibrationLogBookEntry {
  constructor(data = {}) {
    this.id = data.id || uuidv4();
    // Generic parent reference (book_id for books, falls back to other parent keys).
    this.parentId =
      data.book_id ||
      data.calibration_log_book_id ||
      data.parent_id ||
      data.sampling_event_id ||
      "";
    this.calibrationDate = data.calibration_date || null;
    this.calibrationTime = data.calibration_time || null;
    this.instrument = data.instrument || "";
    this.fieldParameter = data.field_parameter || "";
    this.standardUsed = data.standard_used || "";
    this.verification = data.verification || null;
    this.units = data.units || "";
    this.passFail = data.pass_fail || "";
    this.employeeId = data.employee_id || null;
    this.employeeName = data.employee_name || "";
    this.createdAt = data.created_at || null;
    this.updatedAt = data.updated_at || null;
  }

  setCalibrationDate(calibrationDate) {
    this.calibrationDate = calibrationDate || null;
  }

  setCalibrationTime(calibrationTime) {
    this.calibrationTime = calibrationTime || null;
  }

  setInstrument(instrument) {
    this.instrument = instrument || "";
  }

  setFieldParameter(fieldParameter) {
    this.fieldParameter = fieldParameter || "";
  }

  setVerification(verification) {
    this.verification = verification || "";
  }

  setStandardUsed(standardUsed) {
    this.standardUsed = standardUsed || "";
  }

  setUnits(units) {
    this.units = units || "";
  }

  setPassFail(passFail) {
    this.passFail = passFail || "";
  }

  setEmployeeId(employeeId) {
    this.employeeId = employeeId || "";
  }

  setEmployeeName(employeeName) {
    this.employeeName = employeeName || "";
  }

  updateFromPatch(patch) {
    this.calibrationDate = patch.calibration_date;
    this.calibrationTime = patch.calibration_time;
    this.instrument = patch.instrument;
    this.fieldParameter = patch.field_parameter;
    this.standardUsed = patch.standard_used;
    this.verification = patch.verification;
    this.units = patch.units;
  }

  toJson() {
    return {
      id: this.id,
      book_id: this.parentId,
      calibration_date: this.calibrationDate,
      calibration_time: this.calibrationTime,
      instrument: this.instrument,
      standard_used: this.standardUsed,
      field_parameter: this.fieldParameter,
      verification: this.verification,
      units: this.units,
      pass_fail: this.passFail,
      employee_id: this.employeeId,
      employee_name: this.employeeName,
      created_at: this.createdAt,
      updated_at: this.updatedAt,
    };
  }

  // All row data is sent per edit/save (edited in a single modal). The parent id
  // (calibration_log_book_id) is injected by the autosave hook, not included here.
  toPatch(action, patchType = "calibration_log_book_entry") {
    return {
      patch_type: patchType,
      action: action,
      id: this.id,
      calibration_date: this.calibrationDate,
      calibration_time: this.calibrationTime,
      instrument: this.instrument,
      field_parameter: this.fieldParameter,
      standard_used: this.standardUsed,
      verification: this.verification || null,
      units: this.units,
      pass_fail: this.passFail,
      employee_id: this.employeeId,
      employee_name: this.employeeName,
      created_at: this.createdAt,
      updated_at: this.updatedAt,
    };
  }
}
